export function CalendarIcon() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.95825 7.29167C3.95825 6.37119 4.70444 5.625 5.62492 5.625H14.3749C15.2954 5.625 16.0416 6.37119 16.0416 7.29167V14.375C16.0416 15.2955 15.2954 16.0417 14.3749 16.0417H5.62492C4.70444 16.0417 3.95825 15.2955 3.95825 14.375V7.29167Z'
        stroke='#081F24'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6.66675 3.95833V6.875'
        stroke='#081F24'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M13.3333 3.95833V6.875'
        stroke='#081F24'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6.45825 8.95833H13.5416'
        stroke='#081F24'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
